/* eslint-disable prettier/prettier */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../hooks/useUserProfile';

interface Props {
	children: React.ReactNode;
	allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<Props> = ({ children, allowedRoles }) => {
	const { profile } = useUserProfile();

	const role = profile?.rolename?.toLowerCase();

	console.log('User Role:', role);
	console.log('Allowed Roles:', allowedRoles);

	if (!role) return null;

	if (!allowedRoles.includes(role)) {
		return <Navigate to="/dashboard" replace />;
	}

	return <>{children}</>;
};

export default RoleProtectedRoute;
